import { type ComponentProps } from 'react';

import { Button } from '@storeblocks/button';
import { Icon } from '@storeblocks/icon';

import { StatusLayout } from '@storebrand-digital/bank-foundation-components';
import { getText } from '@storebrand-digital/fms-translations';

type Props = Partial<ComponentProps<typeof StatusLayout>>;

export default function ErrorView({
  heading,
  figure = (
    <Icon>
      <img alt="" src="https://assets.storebrand.no/icons/rebrand/binoculars.svg" />
    </Icon>
  ),
  description,
  actions,
  ...props
}: Props) {
  return (
    <StatusLayout
      {...props}
      figure={figure}
      heading={
        heading ?? {
          value: getText('coreFeatures.errorPage.header'),
          level: 1,
          lookLike: 3,
        }
      }
      description={description ?? getText('coreFeatures.errorPage.description')}
      actions={
        actions ?? (
          <>
            <Button variant="secondary" onClick={() => window.location.reload()}>
              {getText('coreFeatures.errorPage.reloadPage')}
            </Button>

            <Button
              variant="tertiary"
              as="a"
              iconRight="arrow-right"
              href={getText('coreFeatures.errorPage.contactSupportUrl')}
            >
              {getText('coreFeatures.errorPage.contactSupport')}
            </Button>
          </>
        )
      }
    />
  );
}
